"use client";

import Icon from "./ui/Icon";
import LazyImage from "./ui/LazyImage";
import staticLogo from "../assets/images/green-logo.png";

type MobileMiniPlayerProps = {
  selectedTrackId: number | undefined;
  isMobileOpen: boolean;
  isPlaying: boolean;
  onTogglePlay: () => void;
  setIsMobileOpen: (open: boolean) => void;
  tracks: Array<{ id: number; cover: string }>;
};

export default function MobileMiniPlayer({
  selectedTrackId,
  isMobileOpen,
  setIsMobileOpen,
  tracks,
  isPlaying,
  onTogglePlay,
}: MobileMiniPlayerProps) {
  const currentTrack = tracks.find((t) => t.id === selectedTrackId);

  if (selectedTrackId === undefined || isMobileOpen) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 bg-green-04/40 backdrop-blur-lg border border-white/15 pr-2 pl-3 py-0.5 shrink-0 rounded-full">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onTogglePlay();
        }}
        className="relative size-12 overflow-hidden rounded-full border border-white/20 bg-black/20"
      >
        <LazyImage
          src={currentTrack?.cover || staticLogo}
          alt="کاور"
          className="h-full w-full object-cover"
        />

        <div className="absolute inset-0 flex items-center justify-center bg-black/35 backdrop-blur-[1px] pointer-events-none">
          {isPlaying ? (
            <Icon icon="Pause" className="size-4 text-white" />
          ) : (
            <Icon icon="Play" className="size-4 text-white" />
          )}
        </div>
      </button>

      <button
        type="button"
        onClick={() => setIsMobileOpen(true)}
        aria-label="باز کردن پلیر"
      >
        <Icon icon="OpenState" className="size-4 text-white shrink-0" />
      </button>
    </div>
  );
}
